import Link from "next/link";
import React from "react";
import { JobListing } from "@lib/types/jobTypes";
import getJobUrl from "@lib/utils/url/getJobUrl";
import SectionHeading from "../../Various/SectionHeading";
import SmallJobCard from "../SmallJobCard";

function RecommendationList({
  title,
  jobs,
}: {
  title: string;
  jobs: JobListing[];
}) {
  if (!jobs.length) {
    return null;
  }

  return <>
    <SectionHeading>{title}</SectionHeading>

    <div className="w-full">
      <div className="grid lg:grid-cols-2 xl:grid-cols-3 overflow-y-auto w-full gap-3">
        {jobs.map((job) => (
          (<Link key={job.id} href={getJobUrl(job, false)} className="h-full">

            <SmallJobCard job={job} className="h-full" />

          </Link>)
        ))}
      </div>
    </div>
  </>;
}

export default RecommendationList;
